/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type Heart_viewer$ref = any;
export type ItemHeartWrapper_viewer$ref = any;
export type ItemHeartWrapper_viewer = {
    readonly " $fragmentRefs": Heart_viewer$ref;
    readonly " $refType": ItemHeartWrapper_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "ItemHeartWrapper_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "LocalArgument",
            "name": "loadPortfolioData",
            "type": "Boolean!",
            "defaultValue": false
        },
        {
            "kind": "LocalArgument",
            "name": "userIds",
            "type": "[String]",
            "defaultValue": []
        }
    ],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "Heart_viewer",
            "args": [
                {
                    "kind": "Variable",
                    "name": "loadPortfolioData",
                    "variableName": "loadPortfolioData"
                },
                {
                    "kind": "Variable",
                    "name": "userIds",
                    "variableName": "userIds"
                }
            ]
        }
    ]
} as any);
(node as any).hash = 'abddb446fdad2128d9f357272503f7ea';
export default node;
